  const sommeMontants= (dataObjects)=> {
     return dataObjects.reduce(
         (total, obj) => total + (parseFloat(obj?.montant) || 0),
         0
     );
    }
     export default sommeMontants;